import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=670a04fb&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670a04fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('670a04fb')) {
      api.createRecord('670a04fb', component.options)
    } else {
      api.reload('670a04fb', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=670a04fb&scoped=true&", function () {
      api.rerender('670a04fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Nh9IKQsVddHK/JS/comp/Accordion.vue"
export default component.exports